import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const DefaultIntegration: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Typography>{t("common.noAdditionalSettings", { defaultValue: "No additional settings required" })}</Typography>
  );
};

export default DefaultIntegration;
